// import COMPANY_API from '@/api/masterData/company.js';

export const formFields = () => {
  return [
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'expenseNoLike',
      name: '费用编号',
      type: 'input',
    },
    {
      prop: 'expenseType',
      name: '费用类型',
      type: 'select',
      options: [{ value: '01', label: '押金' }],
    },
    {
      name: '费用生成日期从',
      prop: 'expenseGenerationDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '费用生成日期至',
      prop: 'expenseGenerationDateEnd',
      type: 'endDaterangePicker',
    },
  ];
};

export const tableColumnList = [
  // {
  //   type: 'checkbox',
  //   visible: true,
  //   width: '50',
  //   fixed: 'left',
  // },
  // {
  //   type: 'seq',
  //   title: '序号',
  //   visible: true,
  //   width: '80',
  // },

  {
    field: 'expenseNo',
    title: '费用编号',
    visible: true,
  },

  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
    visible: true,
  },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
    width: '150',
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'accountPeriod',
    title: '应付账期',
    visible: true,
    width: '150',
  },
  {
    field: 'expenseType',
    title: '费用类型',
    visible: true,
  },
  {
    field: 'originalPrice',
    title: '结算单价(含税)',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unitName',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },
  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
    visible: true,
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
    visible: true,
  },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'businessDocCode',
    title: '业务单据编码',
    visible: true,
  },
  {
    field: 'spaceAssetName',
    title: '空间资产',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '结算单编号',
    visible: true,
  },
  {
    field: 'salesmanName',
    title: '业务员',
    visible: true,
  },
];
